import React from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../SEO/SEO";
import "./NotFound.css";
import "animate.css";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound-container animate__animated animate__fadeIn">
      <SEO
        title="404 | Whisky And Co"
        description="Pagina no encontrada."
        noindex
      />

      <div className="notfound-box">
        <h1 className="notfound-title animate__animated animate__tada">404</h1>
        <p className="notfound-text">
          Ups... no encontramos ese barril de whisky 🥃
        </p>
        <p className="notfound-subtext">
          La página que estás buscando no existe o se evaporó.
        </p>
        <div className="notfound-buttons">
          <button onClick={() => navigate("/")}>Ir al inicio</button>
          <button onClick={() => navigate(-1)}>Volver atrás</button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
